import { Typography } from '@material-ui/core'
import {classNames, withStyles, React, StyledProps, Fragment} from '@api'
import { PrimaryButton } from 'centric-ui-components'
import * as css from './EmptyDrawer.css'

const styles = theme => ({
  emptyText: {
    textAlign: 'center',
    width: 200,
    color: 'rgba(27, 27, 27, 0.54)',
    fontSize: theme.spacing() * 2
  }
})

interface MyProps extends StyledProps {
  classes?: any
  onClickCreateLibrary?: (e) => void
  type?: any
  message?: string,
  createText?: string,
  isCreate?: boolean,
}

@(withStyles as any)(styles)
export class EmptyDrawer extends React.Component<MyProps> {
  static defaultProps = {
    type: 'libraries',
  }

  render() {
    const {
      props: {
        type,
        message,
        classes,
        isCreate,
        onClickCreateLibrary,
        createText,
        className
      }
    } = this

    return (
      <div className={classNames(css.root, className)} data-type='EmptyDrawer'>
        {
          message ?? <Fragment>
            <Typography className={classes.emptyText}>{message || `You have not created any ${type} for this hierarchy selection`}</Typography>
            {isCreate && <PrimaryButton onClick={onClickCreateLibrary}>{createText || `Manage Library`}</PrimaryButton>}
          </Fragment>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/widgets/EmptyDrawer.tsx